<template>
  <div>
    <div class="a-container-form">
      <dropdown-new class="select-w-100-percent" :options="templatesList" v-model="template">
      </dropdown-new>
    </div>

    <template-item :item="item"></template-item>
  </div>
</template>

<script>
  import _ from 'lodash'
  import TemplateType from '@/api/types/template-type'
  import TemplateItem from './TemplateItem'

  export default {
    components: {
      TemplateItem
    },

    data: () => ({
      template: undefined
    }),

    computed: {
      templatesList() {
        let templates = TemplateType.Groups[this.$route.query['kind']];
        let values = TemplateType.values();

        if (!templates) {
          templates = TemplateType.values;
        }
        else {
          templates = templates.map(t => _.find(values, e => e[t]));
        }

        return [{name: this.$t('template-type.empty')}].concat(templates.map(e => {
          return {
            id: e.valueOf(),
            name: this.$t(e.label),
            disabled: !!!_.find(this.templates, { reportType: e.valueOf() })
          }
        }));
      },

      templates() {
        return this.$store.getters.templatesCatalog.items || [];
      },

      item() {
        return _.find(this.templates, { reportType: this.template + '' })
      }
    },

    async created() {
      try {
        await this.$store.dispatch('fetchTemplates');
      }
      catch(e) {
        console.error('unable to fetch list of templates', e);
        this.globalErrorHandler(e);
      }
    }
  }
</script>

<style scoped>

</style>
